var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.254 6.2C21.254 3.05198 18.733 0.5 15.6233 0.5C12.5135 0.5 9.99257 3.05198 9.99257 6.2C9.99257 9.34805 12.5135 11.9 15.6233 11.9C18.733 11.9 21.254 9.34805 21.254 6.2Z",
    fill: "#5D5D5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53296 9.44669C9.58989 9.55588 9.56574 9.69205 9.46777 9.76551C8.74003 10.3108 7.83949 10.6333 6.86463 10.6333C4.44593 10.6333 2.4852 8.64844 2.4852 6.19997C2.4852 3.7515 4.44593 1.76663 6.86463 1.76663C7.83949 1.76663 8.74003 2.08913 9.46777 2.63447C9.56574 2.70793 9.58989 2.84404 9.53296 2.95324C9.02757 3.92274 8.74153 5.02754 8.74153 6.19997C8.74153 7.3724 9.02757 8.47718 9.53296 9.44669Z",
    fill: "#5D5D5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7032 14.0524C20.1612 13.3749 18.1379 13.1667 15.6235 13.1667C13.1069 13.1667 11.0822 13.3753 9.53967 14.0543C7.85934 14.794 6.83806 16.0538 6.30277 17.8326C6.05189 18.6663 6.67051 19.5 7.523 19.5H23.7216C24.5751 19.5 25.1951 18.665 24.9434 17.8298C24.4074 16.0507 23.3846 14.7913 21.7032 14.0524Z",
    fill: "#5D5D5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96862 11.9461C9.48664 11.9787 9.51704 12.6832 9.04106 12.8927C7.73674 13.4669 6.75462 14.3121 6.05028 15.391C5.47232 16.2762 4.57479 16.9667 3.52661 16.9667H1.2986C0.413708 16.9667 -0.231947 16.0766 0.0793678 15.207C0.0972609 15.157 0.115907 15.1073 0.135176 15.0581C0.56361 13.9629 1.29798 13.1567 2.38533 12.6428C3.40624 12.1603 4.68428 11.9612 6.18993 11.901L6.2147 11.9H6.23935C7.12625 11.9 8.05256 11.8885 8.96862 11.9461Z",
    fill: "#5D5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector_1.08a865c37fbae33d98968e737ca587ab.svg";
export { ForwardRef as ReactComponent };